// O typings.d.ts do date-fns 2 declara todos os submódulos num arquivo só, e
// o import/no-duplicates confunde o locale com a raiz do pacote.
/* eslint-disable import/no-duplicates */
import {
  addDays,
  endOfMonth,
  format,
  isToday,
  isYesterday,
  parse,
} from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
/* eslint-enable import/no-duplicates */
import { Agrupamento } from '../../services/hooks/useDashboard';

// parse local, não new Date('yyyy-MM-dd'): este interpreta como UTC e, no
// fuso de Brasília, o dia 01 viraria 31 do mês anterior.
function dataLocal(data: string): Date {
  return parse(data.slice(0, 10), 'yyyy-MM-dd', new Date());
}

export function rotuloEixo(periodo: string, agrupamento: Agrupamento) {
  const data = dataLocal(periodo);
  if (agrupamento === 'mes') return format(data, 'MMM/yy', { locale: ptBR });
  return format(data, 'dd/MM');
}

export const DESCRICAO_AGRUPAMENTO: Record<Agrupamento, string> = {
  dia: 'Por dia',
  semana: 'Por semana',
  mes: 'Por mês',
};

// O intervalo que um ponto do gráfico representa, para o clique na barra
// virar filtro de período.
export function intervaloDoPeriodo(
  periodo: string,
  agrupamento: Agrupamento,
): [string, string] {
  const inicio = dataLocal(periodo);
  const fim =
    agrupamento === 'mes'
      ? endOfMonth(inicio)
      : agrupamento === 'semana'
      ? addDays(inicio, 6)
      : inicio;
  return [format(inicio, 'yyyy-MM-dd'), format(fim, 'yyyy-MM-dd')];
}

export function formatDataHora(dataHora: string | null) {
  if (!dataHora) return '';
  return format(
    parse(dataHora.slice(0, 19), 'yyyy-MM-dd HH:mm:ss', new Date()),
    'dd/MM/yyyy HH:mm',
  );
}

export function formatUltimaAtualizacao(dataHora: string | null) {
  if (!dataHora) return 'Nunca importado';
  const data = parse(dataHora.slice(0, 19), 'yyyy-MM-dd HH:mm:ss', new Date());
  if (isToday(data)) return `Hoje ${format(data, 'HH:mm')}`;
  if (isYesterday(data)) return `Ontem ${format(data, 'HH:mm')}`;
  return format(data, 'dd/MM/yyyy HH:mm');
}

export function formatPercentual(valor: number) {
  return `${valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  })}%`;
}

export function plural(
  quantidade: number,
  singular: string,
  pluralTexto: string,
) {
  return `${quantidade.toLocaleString('pt-BR')} ${
    quantidade === 1 ? singular : pluralTexto
  }`;
}
